var map = {
	".": "BbCp",
	"./": "BbCp",
	"./01_get_common_symbols": "qHSP",
	"./01_get_common_symbols.json": "qHSP",
	"./02_get_ market_traders": "u7QQ",
	"./02_get_ market_traders.json": "u7QQ",
	"./03_get_market_depth": "xaTv",
	"./03_get_market_depth.json": "xaTv",
	"./04_get_market_klines": "l6fp",
	"./04_get_market_klines.json": "l6fp",
	"./05_get_quote_ticker": "mWiW",
	"./05_get_quote_ticker.json": "mWiW",
	"./06_get_market_agg_depth": "eCwL",
	"./06_get_market_agg_depth.json": "eCwL",
	"./07_get_market_price": "p4oz",
	"./07_get_market_price.json": "p4oz",
	"./08_get_market_book_ticker": "OdvA",
	"./08_get_market_book_ticker.json": "OdvA",
	"./09_get_market_history_klines": "Turq",
	"./09_get_market_history_klines.json": "Turq",
	"./10_get_ market_histroy_traders": "MGWO",
	"./10_get_ market_histroy_traders.json": "MGWO",
	"./index": "BbCp",
	"./index.js": "BbCp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EA8X";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/api/market ^.*$
// module id = EA8X
// module chunks = 3